import { format } from "date-fns";
import { DateRangeType } from "../../common/enums/DRCXEnums";
import { TIME_FORMAT_STRING } from "../../common/utilities/TimeframeUtilities";
import { ActionMenuItem, BaseActionEnum, BaseActions } from "../../components/action-menu/ActionMenuItem";
import { VirtualizedListItem } from "../../components/virtualized-list/VirtualizedList";
import i18n from "../../services/localization-service/i18n";
import { IReportScheduleSummaryDTO, IReportTaskSummaryDTO, ReportDeliveryType, ReportTypeEnum, hiddenRecipients } from "../../services/reporting-data-service/ReportScheduleModels";
import { DayOfWeekEnum } from "../../services/alarm-schedule-data-service/Models";
import _ from "lodash";
import { CreateNewIcon } from "../action-menu/ActionMenuIcons";


export enum ScheduledReportsActionEnum {
    GoToAdmin = 'gotoadmin'
}

export type ScheduledReportsActionItem = {
    action: ScheduledReportsActionEnum | BaseActions
} & ActionMenuItem;



export type ScheduledReportsItem = {

} & IReportTaskSummaryDTO & VirtualizedListItem;

export type ReportOption = {
    text: string,
    value: ReportTypeEnum
};


export const reportTypes: ReportOption[] = [{
    text: i18n.t("scheduledReports.reportTypes.all"),
    value: ReportTypeEnum.None
}, {
    text: i18n.t("scheduledReports.reportTypes.custom"),
    value: ReportTypeEnum.Custom
}, {
    text: i18n.t("scheduledReports.reportTypes.groupMarketing"),
    value: ReportTypeEnum.GroupMarketing
}, {
    text: i18n.t("scheduledReports.reportTypes.user"),
    value: ReportTypeEnum.User
}];

// const actionEnums = [
//     BaseActionEnum.Export,
// ];

export const actionItems = [{

    label: i18n.t("actions.newScheduledReportTask"),
    icon: CreateNewIcon,
    action: BaseActionEnum.CreateNew,
    order: 0
}];       


const ScheduledReportsListUtils = {

    shapeData: function(data: IReportTaskSummaryDTO[],
        filterText: string,
        reportType: ReportTypeEnum,
        elynxAdmin: boolean) : ScheduledReportsItem[] {


        const scheduledReports = data?.map(o => {

            const notifications = _.cloneDeep(o.notifications).filter(o => o.deliveryType !== ReportDeliveryType.Email ||
                (o.deliveryType === ReportDeliveryType.Email && (!hiddenRecipients.find(v => v === o.displayText) || elynxAdmin))
                );


            const item = {...o,
                notifications: notifications
                
            } as ScheduledReportsItem;

            return item;
        })
        .filter(o => o.type === reportType || reportType === ReportTypeEnum.None)
        .filter(o => o.name.toLowerCase().indexOf(filterText.toLowerCase()) !== -1 || filterText === '');

        return scheduledReports;
    },
    getScheduleSummary: function (scheduleSummary: IReportScheduleSummaryDTO) {


        const now = new Date();
        const timeValue = format(new Date(now.getFullYear(), 
                                now.getMonth(), 
                                now.getDate(), 
                                scheduleSummary.hour, 
                                scheduleSummary.minute), 
                                TIME_FORMAT_STRING);


        //console.log(`timeValue: ${timeValue} `);

        let frequency = scheduleSummary.frequency;

        if (scheduleSummary.frequencyOption === DateRangeType.Raw) {
        
            //if (scheduleSummary.repeatInterval > 1) {
            
            let range = frequency as DateRangeType;

            // if (scheduleSummary.frequency === DateRangeType.Raw) {
            //     range = scheduleSummary.rep.repeatInterval
            // }

            //switch (frequency) {
            switch (range) {

                case DateRangeType.Year:
                    return `${i18n.t("scheduledReports.steps.details.custom")} ` + 
                            `${scheduleSummary.repeatInterval} ${i18n.t("scheduledReports.steps.details.year")}(s) ` + 
                            `${i18n.t("scheduledReports.steps.details.at")} ${timeValue} ${scheduleSummary.timezoneName}`;

                case DateRangeType.Month:

                    return `${i18n.t("scheduledReports.steps.details.custom")} ` +
                            `${scheduleSummary.repeatInterval} ${i18n.t("scheduledReports.steps.details.month")}(s) ` +
                            `${i18n.t("scheduledReports.steps.details.at")} ${timeValue} ${scheduleSummary.timezoneName}`;

                case DateRangeType.Week:

                    return `${i18n.t("scheduledReports.steps.details.custom")} ` +
                            `${scheduleSummary.repeatInterval} ${i18n.t("scheduledReports.steps.details.week")}(s) ` +
                            `${i18n.t("scheduledReports.steps.details.at")} ${timeValue} ${scheduleSummary.timezoneName}`;

                case DateRangeType.Day:

                    return `${i18n.t("scheduledReports.steps.details.custom")} ` +
                            `${scheduleSummary.repeatInterval} ${i18n.t("scheduledReports.steps.details.day")}(s) ` +
                            `${i18n.t("scheduledReports.steps.details.at")} ${timeValue} ${scheduleSummary.timezoneName}`;

                case DateRangeType.Hour:

                    return `${i18n.t("scheduledReports.steps.details.custom")} ` +
                        `${scheduleSummary.repeatInterval} ${i18n.t("scheduledReports.steps.details.hour")}(s) ` +
                        `${i18n.t("scheduledReports.steps.details.at")} ${timeValue} ${scheduleSummary.timezoneName}`;

                case DateRangeType.Minute:

                    return `${i18n.t("scheduledReports.steps.details.custom")} ` +
                        `${scheduleSummary.repeatInterval} ${i18n.t("scheduledReports.steps.details.minute")}(s) ` +
                        `${i18n.t("scheduledReports.steps.details.at")} ${timeValue} ${scheduleSummary.timezoneName}`;
            }
        }
        else {
            const month = scheduleSummary.nextScheduledTime ? 
                    new Date(scheduleSummary.nextScheduledTime.toLocaleString()).getMonth() + 1 :
                    now.getMonth() + 1;


            let magicalSAppend = scheduleSummary.repeatInterval === 1 ? "" : "s"
            switch (frequency) {
                case DateRangeType.Year:

                    return `${i18n.t("scheduledReports.steps.details.custom")} ` +
                        `${scheduleSummary.repeatInterval} ${i18n.t("scheduledReports.steps.details.year")}(s) ` +
                        `${i18n.t("scheduledReports.steps.details.on")} ` +
                        `${i18n.t("scheduledReports.steps.details.of")} ` +
                        `${month.toString()}/${scheduleSummary.dayOfMonth} ` + 
                        `${i18n.t("scheduledReports.steps.details.at")} ${timeValue} ${scheduleSummary.timezoneName}`;

                case DateRangeType.Month:

                return `${i18n.t("scheduledReports.steps.details.runReportOnDay")} ` +
                `${scheduleSummary.dayOfMonth} ` +
                `${i18n.t("scheduledReports.steps.details.ofThe")} ` +
                `${i18n.t("scheduledReports.steps.details.month")} every ` +
                `${scheduleSummary.repeatInterval === 1 ? '' : scheduleSummary.repeatInterval} ` +
                `${i18n.t("scheduledReports.steps.details.month")}${magicalSAppend} ` +
                `${i18n.t("scheduledReports.steps.details.at")} ${timeValue} ${scheduleSummary.timezoneName}`;


                case DateRangeType.Week:

                    return `${i18n.t("scheduledReports.steps.details.runReportEvery")} ` +
                    `${scheduleSummary.repeatInterval === 1 ? '' : scheduleSummary.repeatInterval} ` +
                    `${DayOfWeekEnum[scheduleSummary.dayOfWeek]} ` +
                    //`${scheduleSummary.dayOfMonth.toString()}${magicalSAppend} ` +
                    `${i18n.t("scheduledReports.steps.details.at")} ${timeValue} ${scheduleSummary.timezoneName}`;

                case DateRangeType.Day:

                    return `${i18n.t("scheduledReports.steps.details.runReportEvery")} ` +
                        `${scheduleSummary.repeatInterval === 1 ? '' : scheduleSummary.repeatInterval} ` +
                        `${i18n.t("scheduledReports.steps.details.day")}${magicalSAppend} ` +
                        `${i18n.t("scheduledReports.steps.details.at")} ${timeValue} ${scheduleSummary.timezoneName}`;

                case DateRangeType.Hour:

                    return `${i18n.t("scheduledReports.steps.details.runReportEvery")} ` +
                        `${scheduleSummary.repeatInterval === 1 ? '' : scheduleSummary.repeatInterval} ` +
                        `${i18n.t("scheduledReports.steps.details.hour")}${magicalSAppend} ` +
                        `${i18n.t("scheduledReports.steps.details.at")} ${scheduleSummary.minute} ` +
                        `${i18n.t("scheduledReports.steps.details.minutesPastTheHour")} in ${scheduleSummary.timezoneName}`;


                case DateRangeType.Minute:

                    return `${i18n.t("scheduledReports.steps.details.custom")} ` +
                        `${scheduleSummary.repeatInterval} ` +
                        `${i18n.t("scheduledReports.steps.details.minute")}(s) ` +
                        `${scheduleSummary.timezoneName}`;
            }
    
            return "Unknown frequency";
        }
                   
    }
    


}

export default ScheduledReportsListUtils;

